// extracted by mini-css-extract-plugin
export default {"container":"slotMachineStrips__container___iUVN","strip":"slotMachineStrips__strip__T343f"};